module.exports = __webpack_public_path__ + "assets/img/Fas.1306a838.png";